import evbus from '@/services/evbus';
import store from '@/store';

export default (to: any, from: any, next: Function) => {
  store.commit('logout'); //remove caches

  window.localStorage.setItem('auth-token', to.query.token);
  store.commit('authToken', to.query.token);
  
  evbus.emit('login:external');
  return next({
    name: 'app.blank'
  });
};
